<template>
<div class="my-4">
  <b-container fluid>
    <b-row class="text-center mb-4" align-h="center" v-if="!permissions.read">
      <b-col>
        <h3>You do not have permissions for this page</h3>
      </b-col>
    </b-row>
    <b-row class="text-center mb-4" align-h="center" v-if="loading && permissions.read">
      <b-col cols="1">
        <i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
      </b-col>
    </b-row>
    <b-row class="mb-4" v-if="!loading && permissions.read">
      <b-col>
        <b-card>
          <b-form-group horizontal class="mt-4">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-btn :disabled="!filter" @click="filter = ''">clear</b-btn>
            </b-input-group>
          </b-form-group>
          <b-form inline>
            <span class="mr-2"><strong>Showing {{rowsShow.length}} out of {{rows.length}} accounts</strong></span>
            <b-button class="mr-2" v-if="permissions.add" variant="outline-primary" :to="{ name: 'AccountAdd' }">add account</b-button>
            <b-form-select v-model="orderBy" :options="orderByOptions"></b-form-select>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-4" v-if="!loading && permissions.read">
      <b-col>
        <b-card>
          <div class="mb-3" v-for="row in rowsShow" :key="row.id">
            <account-simple
              :item="row"
              :username="user.username"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import _ from 'lodash'
import ac from '@/libs/accesscontrol'
import moment from 'moment'

import AccountSimple from '@/components/AccountSimple.vue'

export default {
  name: 'Accounts',
  components: {
    AccountSimple
  },
  computed: {
    rowsShow: function () {
      let rows = []
      rows = this.rows
      if (this.filter.length > 0) {
        rows = rows.filter(x => {
          const term = x.id + ' ' + x.organisation + ' ' + x.key + ' ' + x.licensee
          return term.toUpperCase().match(this.filter.toUpperCase())
        })
      }
      rows = _.orderBy(rows, [this.orderBy])
      return rows
    },
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: function () {
    document.title = "Accounts"
    this.$stat.log({ page: 'account', action: 'open accounts' })
    this.permissions.read = ac.can(this.user.acgroups).readAny('account').granted
    this.permissions.add = ac.can(this.user.acgroups).createAny('account').granted
    if (this.permissions.read) {
      this.load()
    }
  },
  data () {
    const data = {
      permissions: {
        add: false,
        read: false
      },
      filter: '',
      loading: true,
      orderBy: 'organisation',
      orderByOptions: [
        { value: 'organisation', text: 'by name' },
        { value: 'duration', text: 'by expiry' }
      ],
      rows: [],
      statusOptions: [{ value: false, text: 'active' }, { value: true, text: 'deleted' }],
      statusSelected: false
    }
    return data
  },
  methods: {
    load: async function () {
      this.loading = true
      try {
        this.rows = await this.$Amplify.API.get('cosmos', '/standard/account')
        _.each(this.rows, row => {
          row.duration = moment.duration(moment(row.expiry).diff(moment()))
        })
        this.loading = false
      } catch (e) {
        this.$logger.warn('saved ERROR: ', e)
      }
    },
    resetFilters: function () {
      this.statusSelected = false
    }
  }
}
</script>

<style>
</style>
